import { render, staticRenderFns } from "./ControlsComponent.vue?vue&type=template&id=543237a6&scoped=true&"
import script from "./ControlsComponent.vue?vue&type=script&lang=js&"
export * from "./ControlsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ControlsComponent.vue?vue&type=style&index=0&id=543237a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543237a6",
  null
  
)

export default component.exports